import { Component,  ElementRef,  EventEmitter, Input,  OnChanges,  Output, SimpleChanges, ViewChild } from '@angular/core';
import { SharedDataService,DocumentsService } from '../../all-services';
import { DocumentStatut, PafDocument,PS_Supplier_Qual_Docs_2_Result, Supplier, SimpleReponseResult,  DocTyp } from '../../all-models';
import {  of, Subject } from 'rxjs';  // RxJS 6 syntax
import moment from 'moment';
import { finalize, map } from 'rxjs/operators';
import { HttpEventType } from '@angular/common/http';
import { Observable, Subscription } from 'rxjs';
import { saveAs } from '@progress/kendo-file-saver';

@Component({
  selector: 'supplier-qual-doc-row',
  templateUrl: './supplier-qual-doc-row.component.html',
  styleUrls: ['./supplier-qual-doc-row.component.scss']
})
export class SupplierQualDocRowComponent implements OnChanges {
  @Input() lstPafDocuments!: PafDocument[];
  @Input() lstDocTyps!: DocTyp[] ;
  @Input()lstDocStatuts!: DocumentStatut[];  
  @Input() supplier: Supplier = new Supplier();
  @Input() supplierDoc?: PS_Supplier_Qual_Docs_2_Result = null;
  @Output() reloadList: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() readonly:boolean = false;
  emptySupplierDoc?: PS_Supplier_Qual_Docs_2_Result = null;
  @Input() isEmptyRowLine: boolean = false;

  @ViewChild('fileUpload') fileUpload: ElementRef;
  dateInput: Date = null;

  get OuiNon():boolean{
    return (this.supplierDoc ? this.supplierDoc.TopFic==1 : false);
  }
  set OuiNon(value:boolean){
    if (this.supplierDoc){
      let oldVal:number = this.supplierDoc?.TopFic ||0;
      let newVal = (oldVal+1) % 2;
      this.supplierDoc.TopFic = newVal;
      if ((value && this.isExpired) 
        || (!value && this.supplierDoc.DocId && this.supplierDoc.FullPath)) {
        let confirmCallback: () => any = ()=>{
          this.supplierDoc.TopFic = newVal;
        };
        let cancelCallback: () => any = ()=>{
          this.supplierDoc.TopFic =  oldVal;          
        };
        this._archiveOrDeleteFile(this.canDelete,newVal).then(confirmCallback,cancelCallback);
      } 
    }
  }
  
  public get requiredFileType() : string {
    return this.sharedDatasSvc.allowedExtensions.join(',');
  }
  fileName = '';
  uploadProgress: number = null;
  uploadSub: Subscription;



 constructor(
   public sharedDatasSvc: SharedDataService, 
    public docsSvc : DocumentsService) {}
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['supplierDoc'] && this.supplierDoc!=null){
      if (this.supplierDoc.AddEmptyRow == 1){
        this.emptySupplierDoc = new PS_Supplier_Qual_Docs_2_Result();
        this.emptySupplierDoc.RefDocId= this.supplierDoc.RefDocId;
        this.emptySupplierDoc.TopMultiple = this.supplierDoc.TopMultiple;
        this.emptySupplierDoc.TopInputDescription= this.supplierDoc.TopInputDescription;
        this.emptySupplierDoc.Screen= this.supplierDoc.Screen;
        this.emptySupplierDoc.DisplayRank= this.supplierDoc.DisplayRank;
        this.emptySupplierDoc.SupplierId= this.supplierDoc.SupplierId;
        this.emptySupplierDoc.TopDatInputIsEcheance= this.supplierDoc.TopDatInputIsEcheance;
        this.emptySupplierDoc.CanUpload= 1;
        this.emptySupplierDoc.CanArchive= 0;
        this.emptySupplierDoc.CanDelete= 0;
        this.emptySupplierDoc.DocId = 0;
      } else {
        this.emptySupplierDoc = null;
      }
    }
  }

  clearDoc(doc:PS_Supplier_Qual_Docs_2_Result,topFic:number){
    if (!doc) return;
    doc.DocId = 0;
    doc.DateExpi = null;
    doc.FullPath = undefined;
    doc.TopFic = topFic;
    doc.CanArchive = 0;
    doc.CanDelete = 0;
    doc.CanUpload = this.readonly ? 0: 1;
    doc.StatutCod = 'A_DEPOSER';
    doc.StatutId = 1;
    doc.StatutLib='';
    this.uploadProgress = null;
    this.uploadSub = null;
  }


  reset() {
    this.uploadProgress = null;
    this.uploadSub = null;
    this.reloadList.emit(true);
  }
  
  get pafDocument(): PafDocument | undefined {
    return this.lstPafDocuments.find(d => d.Id == this.supplierDoc?.RefDocId);
  }

  get getLblCod(): string {
    return this.pafDocument?.LblCod;
  }
  
  get getStatutDoc(): DocumentStatut | null {
    return this.lstDocStatuts.find(s => s.Id == this.supplierDoc?.StatutId);
  }

  get getFilename(): string {
    if (!this.supplierDoc?.FullPath) return '';
    return this.supplierDoc?.FullPath.replace(/^.*[\\\/]/, '');
  }
  
  get showButtonDeposer(): boolean {
    if (!this.supplierDoc) return false;
    if (!this.supplierDoc.DocId) return true;
    let Cod:string = this.getStatutDoc?.Cod;
    if (!Cod) return false;
    if (Cod.indexOf('ARELANCER') >= 0) return true;
    return ['A_DEPOSER', 'NON_CONFORME', 'EXPIRE'].some(c => c == this.getStatutDoc.Cod);
  }
  
  btnImportClick(doc: PS_Supplier_Qual_Docs_2_Result): void {     
    const pafDoc: PafDocument=this.pafDocument;
    if (pafDoc?.ImportAction){
      this.docsSvc.importAction(pafDoc.ImportAction.replace('{supplierId}', this.supplier.Id.toString()))
      .subscribe((res:SimpleReponseResult) => {
        if (res.Ok){
          this.reset();
        } else {
          this.sharedDatasSvc.alert(res.Message);
        }
      });
    }
  }
  
  btnDownloadTemplateClick(doc: PS_Supplier_Qual_Docs_2_Result): void { 
    const pafDoc: PafDocument=this.pafDocument;
    if (pafDoc?.TemplatePath){
      this.docsSvc.downloadTemplate(pafDoc.Id)
      .subscribe(blob => {
        saveAs(blob, pafDoc?.TemplatePath);
      });
    }
  }
  
  btnDownloadFileClick(): void {
    this.docsSvc.downloadFile(this.supplier.Id, this.supplierDoc?.DocId)
      .subscribe(blob => {
        saveAs(blob, this.getFilename);
      });
  }

  
  isSizeAllowed(file: File): boolean{
    return file.size<=this.sharedDatasSvc.maxFileSize;
  }
  iSExtensionAllowed(filename:string):boolean{
    let ext= ('.'+ filename.split('.')[filename.split('.').length-1]).toUpperCase();
    return this.sharedDatasSvc.allowedExtensions.some(e=>e==ext);
  }
  controleDateInput (doc:PS_Supplier_Qual_Docs_2_Result,promptAlert:boolean = false) : boolean {
    if (!doc) return false;
    let pafDoc:PafDocument = this.pafDocument;      
    if (pafDoc.TopInputDat==1){
      if (!this.dateInput){
        if (promptAlert) this.sharedDatasSvc.pafAlert('Msg_Date_Manquante');
        return false;
      }
      let now = moment();
      if (pafDoc.TopDatInputIsEcheance==1 &&  now.isSameOrAfter(this.dateInput, "days")) {
        if (promptAlert) this.sharedDatasSvc.pafAlert('Msg_Date_Expiration_posterieure');
        return false;
      } 
      if (pafDoc.TopDatInputIsEcheance==0 &&  now.isBefore(this.dateInput, "days")) {
        if (promptAlert) this.sharedDatasSvc.pafAlert('Msg_Date_Document_anterieure');
        return false;
      }      
    }
    return true;
  }


  minInputDate(pafDoc:PafDocument) : Date | undefined {
    if (!pafDoc) return undefined;   
    if (pafDoc.TopInputDat==1 && pafDoc.TopDatInputIsEcheance==1) {
        return moment().add(1,'day').toDate();
    }
    return undefined;
  }

  maxInputDate(pafDoc:PafDocument) : Date | undefined {
    if (!pafDoc) return undefined;   
    if (pafDoc.TopInputDat==1 && pafDoc.TopDatInputIsEcheance!=1) {
        return moment().toDate();
      } 
    return undefined;
  }


  get isDateValid():boolean{
    return this.controleDateInput(this.supplierDoc,false);
  }

  private fileIsDropping: boolean = false;
  onFilesDropped(event:any):void{
    let files:FileList=<FileList>event;
    const file: File = files[0];
    if (file) {
      if (!this.iSExtensionAllowed(file.name)) {
        this.sharedDatasSvc.pafAlert('Extension_non_autorisee');
        this.fileUpload.nativeElement.value = "";
          return;
      }
      if (!this.isSizeAllowed(file)) {
          this.sharedDatasSvc.pafAlert('Fichier_trop_volumineux');
          this.fileUpload.nativeElement.value = "";
          return;
      }
      if (this.supplierDoc.TopInputDescription==1 && !this.supplierDoc.Description){
        this.sharedDatasSvc.pafAlert('Precisez_la_description_du_document');
        this.fileUpload.nativeElement.value = "";
        return;
      }
      let pafDoc:PafDocument = this.pafDocument; 
      if (!this.controleDateInput(this.supplierDoc,true)){
        this.fileUpload.nativeElement.value = "";
        return;
      }
      if (this.fileIsDropping) {
        this.sharedDatasSvc.pafAlert('Fichier_en_cours_d_import');
        this.fileUpload.nativeElement.value = "";
        return;
      }
      this.fileName = file.name;
      const formData = new FormData();
      formData.append("regulDocFile", file);
      if (pafDoc.TopInputDat==1) {
        formData.append("dateInput",this.dateInput.toDateString());
      }
      if (pafDoc.TopInputDescription==1) {
        formData.append("description",this.supplierDoc.Description);
      }
      this.fileIsDropping = true;
      const upload$ = this.docsSvc.uploadQualityFile(this.supplier.Id, this.supplierDoc.RefDocId, (this.supplierDoc.DocId||0), formData)
        .pipe(
          finalize(() => {
            this.fileIsDropping=false;
            this.reset();
          })
        );

      this.uploadSub = upload$.subscribe(event => {
        if (event.type == HttpEventType.UploadProgress) {
          this.uploadProgress = Math.round(100 * (event.loaded / event.total));
        }
      })
    }
  }

  onFileSelected(event: any) {
    this.onFilesDropped( event.target.files);
  }

  get getInformations():Observable<string>{
    if (this.supplierDoc?.TopInputDescription==1) {
      return of(this.supplierDoc?.Description);
    } else if ((this.pafDocument?.Informations||'')!='') {
       return this.sharedDatasSvc.getLabel(this.pafDocument?.Informations)
       .pipe(map((res:string)=>res.replace('\n','<BR \>')));
    } else 
    {
      return of('');
    }
  }
  
  isDownloadDisabled():boolean{
    return  (this.pafDocument.TopInputDat==1 
              && (this.dateInput==null ||!this.controleDateInput(this.supplierDoc))
            ) 
            || (this.supplierDoc.TopInputDescription==1 && !this.supplierDoc.Description);
  }

  cancelUpload() {
    this.uploadSub.unsubscribe();
    this.reset();
  }


  get isExpired(): boolean {
    return  this.supplierDoc?.StatutCod=='EXPIRE';
  }
  
  getDateLabel(doc: PafDocument):string{
    if (doc?.TopDatInputIsEcheance){
      return 'Date_echeance'
    } else {
      return 'Date_document';
    }
  }
  
  getDateTooltip(doc: PafDocument):string{
    if (doc?.TopDatInputIsEcheance){
      return 'La_date_doit_etre_superieure_a_la_date_du_jour'
    } else {
      return 'La_date_doit_etre_inferieure_ou_egale_a_la_date_du_jour';
    }
  }
  
 get dateFormatPalceHolder():any{
  return {
        year: '____', month: '__', day: '__'
      };  
  }

  get btnUploadTooltip():string{
    if (!this.isDownloadDisabled()){
      return 'Cliquer_ou_faire_glisser_le_fichier_ici';
    } else {
      return 'La_saisie_de_la_date_est_requise';
    }
  }

  descriptionPlaceHolder(): Observable<string>{
    return this.sharedDatasSvc.getLabel('Description');
  }

  emptyDocReset(param:boolean):void{
    this.reset();
  }

  get canUpload():boolean {
    if (!this.supplierDoc) return false;
    return !this.readonly && this.supplierDoc?.CanUpload==1 && this.uploadProgress == null;
  }

  get canDelete():boolean {
    if (!this.supplierDoc) return false;
    return !this.readonly && this.supplierDoc?.CanDelete==1;
  }

 get canArchive():boolean {
    if (!this.supplierDoc) return false;
    return !this.readonly && this.supplierDoc?.CanArchive==1;
  }

  private _archiveOrDeleteFile(canDelete : boolean,topFic:number): Promise<void>{
    let subject :Subject<void> = new Subject<void>();
    if (!this.supplierDoc) subject.next();
    this.sharedDatasSvc.pafConfirm(canDelete ? 'Confirmer_suppression_fichier' : 'Confirmer_archivage_fichier' ,
      ()=>this.suppressFile(topFic).then(
        ()=>subject.next(),
        (reason)=>subject.error(reason)
      )
    ,()=>{
      subject.error(undefined);
    });
    return subject.toPromise();
  }

  suppressFile(topFic: number): Promise<void> {
    let subject: Subject<void> = new Subject<void>();
    this.sharedDatasSvc.WindowLock();
    this.docsSvc.deleteQualityFile(this.supplier.Id, this.supplierDoc.DocId)
      .subscribe({
        next: (res: SimpleReponseResult) => {
          this.sharedDatasSvc.WindowUnlock();
          if (res.Ok) {
            this.clearDoc(this.supplierDoc, topFic);
            subject.next();
          } else {
            this.sharedDatasSvc.alert(res.Message, () => subject.error(res.Message));
          }
        },
        error: (reason) => {
          this.sharedDatasSvc.WindowUnlock();
          subject.error(reason);
        }
      });
    return subject.toPromise();
  }


  get showDateExpi():boolean {
    if (!this.supplierDoc) return false;
    if (this.showDateControl) return false;
    return (this.supplierDoc.FullPath!=null) && (this.supplierDoc?.DateExpi!=null);
  }
  
  get showIsExpiredDate():boolean {
    if (!this.supplierDoc) return false;
    return (!!this.supplierDoc.FullPath) && (!!this.supplierDoc?.DateExpi) && this.isExpired && (!this.supplierDoc!.TopFic);// && !this.IsReferenced;
  }

  get showExpiredAtDate():boolean {
    if (!this.supplierDoc) return false;
    
    return this.showDateExpi && !this.isExpired;
  }

  get showUploadButton():boolean {
    if (!this.supplierDoc) return false;
    return this.canUpload && !this.readonly;
  }

  get showFilename():boolean {
    if (!this.supplierDoc) return false;
    return  !!this.supplierDoc.FullPath; // && !(this.isExpired && this.IsReferenced);
  }

  get showDateControl():boolean {
    return this.canUpload && !this.readonly;
  }

  get IsReferenced():boolean{
    return this.supplier?.StatutId==10;
  }
}